import { config } from '../config';
import { init as identityReady } from '../services/schibstedAccount';

import { PLAYER_ELEMENT_ID } from './configuration';

import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { StreamPlayerInstance } from '../types/global';

const TOKEN_V2_URL = 'https://api.vg.no/svp/token/v2/';

let resolvePlayer: (value: StreamPlayerInstance) => void;
const playerPromise: Promise<StreamPlayerInstance> = new Promise((resolve) => {
  resolvePlayer = resolve;
});

export function getStreamPlayer(): Promise<StreamPlayerInstance> {
  return playerPromise;
}

function create(asset: SvpAssetAdditional | undefined, time?: number): void {
  const player = window.StreamPlayer!.createPlayer({
    vendor: config.provider as string,
    ...(asset ? { asset } : {}),
    node: PLAYER_ELEMENT_ID,
    skin: true,
    tokenV2Url: TOKEN_V2_URL,
    identityReady,
    autoplay: true,
    ...(time ? { time } : {}),
  });
  resolvePlayer(player);
  document.dispatchEvent(new CustomEvent('streamPlayerReady'));
}

export function initializeStreamPlayer(
  asset?: SvpAssetAdditional,
  time?: number
): Promise<StreamPlayerInstance> {
  if (window.StreamPlayer) {
    create(asset, time);
  } else {
    const script = document.getElementById(
      'stream-player-sdk'
    ) as HTMLScriptElement | null;
    script?.addEventListener('load', () => create(asset, time), { once: true });
  }

  return playerPromise;
}

export async function playNextStreamAsset(
  asset: SvpAssetAdditional,
  time?: number
): Promise<void> {
  const player = await playerPromise;
  await player.playNext({ vendor: config.provider as string, asset });
  if (time) {
    await player.seek(time);
  }
}
